// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2PgtS","content":"ManualTimeModal_content__XAqxR"};